module.exports = __webpack_public_path__ + "static/media/game-ranking.b3d10a57.svg";